export default "__VITE_ASSET__1ad4e1ca__"